/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* components */
import ConversionInPage from './components/ConversionInPage';

/* utilities */
import { parseDataToProps } from '~/utilities';

const conversionInPageNodes = Array.from(document.querySelectorAll('.conversion-flow-mobile-vdp'));
[...conversionInPageNodes].forEach((node) => render(<ConversionInPage {...parseDataToProps(node.dataset)} />, node));
